<template>
  <div>
    <Navbar activeDirectory="storico" activePage="lavori"></Navbar>
    
    <div class="container-fluid py-4">
      <!-- PAGE HEADER -->
      <div class="row mb-4">
        <div class="col-12">
          <div class="d-flex align-items-center justify-content-between flex-wrap" style="gap:12px;">
            <div class="d-flex align-items-center">
              <div class="cw-header-icon mr-3">
                <i class="mdi mdi-wrench"></i>
              </div>
              <div class="text-left">
                <h3 class="mb-0 font-weight-bold text-dark">Modifica Lavoro</h3>
                <p class="mb-0 text-muted small">Visualizza e gestisci le informazioni e lo storico delle revisioni</p>
              </div>
            </div>
            <div class="d-flex align-items-center flex-wrap" style="gap:10px;">
              <button
                class="cw-btn-light"
                @click="downloadPDF()"
                v-if="!lavoro.deleted"
              >
                <i class="mdi mdi-file-pdf-box text-danger mr-1" style="font-size:1.1rem; vertical-align:middle;"></i> Relazione PDF
              </button>
              <router-link :to="{ name: 'history', params: { scope: 'lavori' } }" class="cw-btn-light">
                <i class="mdi mdi-arrow-left mr-1"></i> Torna ai lavori
              </router-link>
            </div>
          </div>
        </div>
      </div>

      <!-- ALERT LAVORO ELIMINATO -->
      <div class="row mb-4" v-if="lavoro.deleted">
        <div class="col-12">
          <div class="cw-alert-warning d-flex align-items-center justify-content-between flex-wrap" style="gap: 12px;">
            <div class="d-flex align-items-center">
              <i class="mdi mdi-alert-outline mr-2 h5 mb-0" style="color: #92400e;"></i>
              <span>Questo lavoro è stato eliminato, pertanto non è presente nei report e nelle statistiche.</span>
            </div>
            <button class="au-btn-warning btn-sm" @click="confirmReopen()">
              <i class="mdi mdi-restore mr-1"></i> Ripristina lavoro
            </button>
          </div>
        </div>
      </div>

      <div class="row">
        <!-- COLONNA SINISTRA: Form di modifica e Foto -->
        <div class="col-12 col-lg-7 mb-4">
          <div class="cw-card mb-4">
            <div class="cw-section-title">
              <span class="cw-step-num">1</span>Modifica Informazioni
            </div>

            <form type="multipart/form-data" ref="editForm" @submit.prevent="confirmNewRevision">
              
              <!-- Squadra Incaricata -->
              <div class="form-group mb-4" v-if="lavoro.team">
                <label class="cw-label">Squadra Incaricata <span class="text-danger">*</span></label>
                <div class="cw-select-wrap">
                  <i class="mdi mdi-account-multiple cw-field-icon"></i>
                  <select v-model="lavoro.team.id" class="cw-select" required>
                    <option value="" disabled>Seleziona squadra...</option>
                    <option v-for="team in teams" :key="team.uid" :value="team.uid">{{ team.team }}</option>
                    <option v-if="lavoro.team.id && !teams.find(t => t.uid === lavoro.team.id)" :value="lavoro.team.id">
                      {{ lavoro.team.nome || ('Squadra #' + lavoro.team.id) }}
                    </option>
                  </select>
                  <i class="mdi mdi-chevron-down cw-select-arrow"></i>
                </div>
              </div>

              <!-- Asset Coinvolto (Obbligatorio) -->
              <div class="form-group mb-4" v-if="lavoro && assetsForModule.length > 0">
                <label class="cw-label">Asset Coinvolto <span class="text-danger">*</span></label>
                <div class="cw-select-wrap">
                  <i class="mdi mdi-cogs cw-field-icon"></i>
                  <select v-model="lavoro.fk_asset" class="cw-select" :required="assetsForModule.length > 0" @change="onAssetChange">
                    <option :value="null" disabled>Seleziona asset...</option>
                    <option v-for="asset in assetsForModule" :key="asset.id" :value="asset.id">
                      {{ asset.identificativo }} ({{ asset.asset_type_nome }})
                    </option>
                    <option v-if="lavoro.fk_asset && !assetsForModule.find(a => a.id === lavoro.fk_asset)" :value="lavoro.fk_asset">
                      {{ lavoro.asset_identificativo || ('Asset #' + lavoro.fk_asset) }}
                    </option>
                  </select>
                  <i class="mdi mdi-chevron-down cw-select-arrow"></i>
                </div>
              </div>

              <!-- Tipologia Intervento -->
              <div class="form-group mb-4">
                <label class="cw-label">Tipologia Intervento <span class="text-danger">*</span></label>
                <div class="cw-select-wrap">
                  <i class="mdi mdi-wrench-outline cw-field-icon"></i>
                  <select
                    name="intervento"
                    v-model="lavoro.intervento"
                    class="cw-select"
                    required
                    @change="onInterventoChange"
                  >
                    <option value="" disabled>Seleziona tipologia...</option>
                    <option v-for="item in interventi" :key="item.id" :value="item.codice">{{ item.nome }}</option>
                    <option v-if="lavoro.intervento && !interventi.find(i => i.codice === lavoro.intervento)" :value="lavoro.intervento">
                      {{ nomeIntervento(lavoro.intervento, interventi) }}
                    </option>
                  </select>
                  <i class="mdi mdi-chevron-down cw-select-arrow"></i>
                </div>
              </div>

              <!-- Distanza in metri -->
              <div class="form-group mb-4" v-if="lavoro.distanza !== undefined && lavoro.distanza !== null">
                <label class="cw-label">Distanza (metri)</label>
                <div class="cw-input-wrap">
                  <i class="mdi mdi-ruler cw-field-icon"></i>
                  <input
                    name="distanza"
                    v-model="lavoro.distanza"
                    type="number"
                    class="cw-input"
                    placeholder="Inserisci distanza..."
                  />
                </div>
              </div>

              <!-- Buche Riparate -->
              <div class="form-group mb-4" v-if="lavoro.numero_buche !== undefined && lavoro.numero_buche !== null">
                <label class="cw-label">Buche riparate</label>
                <div class="cw-input-wrap">
                  <i class="mdi mdi-hammer cw-field-icon"></i>
                  <input
                    name="buche"
                    v-model="lavoro.numero_buche"
                    type="number"
                    class="cw-input"
                    placeholder="Numero di buche..."
                  />
                </div>
              </div>

              <!-- Foto del Lavoro -->
              <div class="form-group mb-0">
                <label class="cw-label mb-3">Foto del Lavoro</label>
                <div class="row">
                  <!-- Foto Inizio -->
                  <div class="col-12 col-sm-6 mb-3 mb-sm-0">
                    <div class="border rounded p-3 bg-light text-center h-100 d-flex flex-column justify-content-between">
                      <div class="mb-2">
                        <span class="badge badge-primary px-3 py-1 rounded-pill">Inizio</span>
                      </div>
                      
                      <div v-if="!showFotoInizioUploader" class="position-relative my-2">
                        <img
                          :src="lavoro.inizio.foto"
                          class="img-fluid rounded shadow-sm"
                          style="max-height: 200px; object-fit: contain; cursor: pointer; background: #eaeaea;"
                          @click="showFotoInizioUploader = true"
                          v-if="lavoro.inizio && lavoro.inizio.foto"
                        />
                        <div v-else class="text-muted py-4 small">
                          <i class="mdi mdi-image-off-outline h3 d-block mb-1"></i> Nessuna foto
                        </div>
                        <button
                          type="button"
                          class="btn btn-sm btn-light rounded-circle shadow-sm position-absolute"
                          style="top: 8px; right: 8px;"
                          @click="showFotoInizioUploader = true"
                        >
                          <i class="mdi mdi-pencil text-primary"></i>
                        </button>
                      </div>

                      <div v-else class="py-3">
                        <div class="cw-input-wrap">
                          <i class="mdi mdi-image-plus cw-field-icon"></i>
                          <input
                            @change="processFoto($event, 'inizio')"
                            type="file"
                            class="cw-input pt-2"
                          />
                        </div>
                        <button
                          type="button"
                          class="btn btn-link btn-sm text-muted mt-2 d-inline-block"
                          @click="showFotoInizioUploader = false"
                        >
                          Annulla
                        </button>
                      </div>
                    </div>
                  </div>

                  <!-- Foto Fine -->
                  <div class="col-12 col-sm-6">
                    <div class="border rounded p-3 bg-light text-center h-100 d-flex flex-column justify-content-between">
                      <div class="mb-2">
                        <span class="badge badge-secondary px-3 py-1 rounded-pill">Fine</span>
                      </div>

                      <div v-if="!showFotoFineUploader" class="position-relative my-2">
                        <img
                          :src="lavoro.fine.foto"
                          class="img-fluid rounded shadow-sm"
                          style="max-height: 200px; object-fit: contain; cursor: pointer; background: #eaeaea;"
                          @click="showFotoFineUploader = true"
                          v-if="lavoro.fine && lavoro.fine.foto"
                        />
                        <div v-else class="text-muted py-4 small">
                          <i class="mdi mdi-image-off-outline h3 d-block mb-1"></i> Nessuna foto
                        </div>
                        <button
                          type="button"
                          class="btn btn-sm btn-light rounded-circle shadow-sm position-absolute"
                          style="top: 8px; right: 8px;"
                          @click="showFotoFineUploader = true"
                        >
                          <i class="mdi mdi-pencil text-primary"></i>
                        </button>
                      </div>

                      <div v-else class="py-3">
                        <div class="cw-input-wrap">
                          <i class="mdi mdi-image-plus cw-field-icon"></i>
                          <input
                            @change="processFoto($event, 'fine')"
                            type="file"
                            class="cw-input pt-2"
                          />
                        </div>
                        <button
                          type="button"
                          class="btn btn-link btn-sm text-muted mt-2 d-inline-block"
                          @click="showFotoFineUploader = false"
                        >
                          Annulla
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </form>
          </div>

          <!-- FOOTER AZIONI -->
          <div class="cw-footer d-flex align-items-center justify-content-between flex-wrap" style="gap:12px;">
            <div>
              <small class="text-muted" v-if="!lavoro.deleted">
                Premi "Nuova revisione" per salvare le modifiche apportate.
              </small>
              <small class="text-muted" v-else-if="lavoro.deleted">
                Questo lavoro è stato eliminato.
              </small>
            </div>
            <div class="d-flex flex-wrap align-items-center" style="gap:12px;">
              <button
                class="au-btn-danger"
                @click="confirmDeletion()"
                v-if="!lavoro.deleted"
              >
                <i class="mdi mdi-trash-can-outline mr-1"></i> Elimina lavoro
              </button>
              
              <button
                class="cw-btn-light"
                @click="downloadPDF()"
                v-if="!lavoro.deleted"
              >
                <i class="mdi mdi-file-pdf-box text-danger mr-1" style="font-size:1.1rem; vertical-align:middle;"></i> Relazione PDF
              </button>

              <button
                class="cw-btn-submit"
                @click="confirmNewRevision()"
                v-if="!lavoro.deleted"
              >
                <i class="mdi mdi-check-circle-outline mr-1"></i> Nuova revisione
              </button>
            </div>
          </div>
        </div>

        <!-- COLONNA DESTRA: Riepilogo e Storico -->
        <div class="col-12 col-lg-5">
          
          <!-- Riepilogo Dettagli -->
          <div class="cw-card mb-4">
            <div class="cw-section-title">
              <span class="cw-step-num">2</span>Dettagli del Lavoro
            </div>
            
            <div class="row">
              <div class="col-6 detail-item">
                <div class="detail-label">ID Lavoro</div>
                <div class="detail-value text-primary font-weight-bold">#{{ lavoro.id }}</div>
              </div>
              <div class="col-6 detail-item">
                <div class="detail-label">Stato Revisione</div>
                <div class="detail-value">
                  <span class="badge" :class="lavoro.version > 0 ? 'badge-info' : 'badge-light border'">
                    {{ lavoro.version > 0 ? 'Revisione ' + lavoro.version : 'Versione originale' }}
                  </span>
                </div>
              </div>
              <div class="col-12 detail-item">
                <div class="detail-label">Squadra / Operatore </div>
                <div class="detail-value">
                  {{ (lavoro.team && lavoro.team.nome) ? lavoro.team.nome : '-' }}
                </div>
              </div>
              <div class="col-12 detail-item">
                <div class="detail-label">Strada Interessata</div>
                <div class="detail-value font-weight-semibold">
                  <i class="mdi mdi-road-variant text-muted mr-1"></i>
                  {{ lavoro.strada }}
                </div>
              </div>
              <div class="col-12 detail-item" v-if="lavoro.inizio && lavoro.inizio.latitudine">
                <div class="detail-label">Coordinate Inizio</div>
                <div class="detail-value text-muted small">
                  {{ lavoro.inizio.latitudine }}, {{ lavoro.inizio.longitudine }}
                </div>
              </div>
              <div class="col-12 detail-item" v-if="lavoro.fine && lavoro.fine.latitudine">
                <div class="detail-label">Coordinate Fine</div>
                <div class="detail-value text-muted small">
                  {{ lavoro.fine.latitudine }}, {{ lavoro.fine.longitudine }}
                </div>
              </div>
              <div class="col-6 detail-item" v-if="lavoro.distanza_misurata">
                <div class="detail-label">Distanza Misurata</div>
                <div class="detail-value">{{ lavoro.distanza_misurata }} m</div>
              </div>
              <div class="col-12 detail-item">
                <div class="detail-label">Avviato il</div>
                <div class="detail-value">
                  <i class="mdi mdi-calendar-clock text-muted mr-1"></i>
                  {{ lavoro.inizio ? formatTimestampToLocalDate(lavoro.inizio.tempo) : '-' }}
                </div>
              </div>
              <div class="col-12 detail-item" v-if="lavoro.fine && lavoro.fine.tempo">
                <div class="detail-label">Concluso il</div>
                <div class="detail-value">
                  <i class="mdi mdi-calendar-check text-muted mr-1"></i>
                  {{ formatTimestampToLocalDate(lavoro.fine.tempo) }}
                </div>
              </div>
            </div>
          </div>

          <!-- Storico Revisioni -->
          <div class="cw-card">
            <div class="cw-section-title">
              <span class="cw-step-num">3</span>Storico Revisioni
            </div>
            
            <div class="table-responsive">
              <table class="au-table">
                <thead>
                  <tr>
                    <th>Versione</th>
                    <th>Revisore</th>
                    <th>Data</th>
                  </tr>
                </thead>
                <tbody>
                  <tr
                    v-for="item in revisioni"
                    :key="item.id"
                    style="cursor: pointer;"
                    :class="{ 'active-row': revisioneSelected == item.version }"
                    @click="lavoro = JSON.parse(JSON.stringify(item)); showFotoInizioUploader = false; showFotoFineUploader = false; revisioneSelected = item.version; fetchInterventions();"
                  >
                    <td>
                      <span class="badge rounded-pill" :class="item.version > 0 ? 'badge-primary' : 'badge-light border'">
                        {{ item.version > 0 ? 'Rev. ' + item.version : 'Originale' }}
                      </span>
                    </td>
                    <td>
                      <span v-if="item.version > 0 && item.editor">
                        <i class="mdi mdi-account-edit-outline text-muted mr-1"></i>
                        {{ item.editor.nome }}
                      </span>
                      <span v-else class="text-muted">-</span>
                    </td>
                    <td class="text-muted small">
                      {{ item.version > 0 ? formatTimestampToLocalDate(item.update_time) : '-' }}
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>

        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { Navbar } from "@/components";
import { nomeIntervento } from "@/utils/intervento";

export default {
  components: {
    Navbar,
  },

  data() {
    return {
      lavoro: {
        team: {},
        inizio: {},
        fine: {},
      },
      revisioni: [],
      revisioneSelected: 0,
      ultimaRevisione: 0,
      showFotoInizioUploader: false,
      showFotoFineUploader: false,
      fotoInizio: null,
      fotoFine: null,
      teams: [],
      assets: [],
      interventi: [],
    };
  },

  computed: {
    assetsForModule() {
      if (!this.lavoro || !this.lavoro.fk_module || this.assets.length === 0) return [];
      return this.assets.filter(a => a.fk_module === this.lavoro.fk_module || a.module_id === this.lavoro.fk_module);
    }
  },

  mounted() {
    if (localStorage.getItem("tipologia") != "B") {
      this.$router.push({ name: "home" });
    }

    this.fetchData();
  },

  methods: {
    nomeIntervento,

    fetchData() {
      this.axios
        .get(`dockyard/${this.$route.params.uuid}/versions`)
        .then((response) => {
          this.revisioni = response.data;
          this.lavoro = response.data[0];
          this.revisioneSelected = this.lavoro.version;
          this.ultimaRevisione = this.lavoro.version;
          const lotto = this.lavoro.lotto || localStorage.getItem("lotto") || "1";
          this.fetchTeams(lotto);
          this.fetchAssets(lotto);
        });
    },

    fetchTeams(lotto) {
      this.axios.get(`teams/${lotto}`).then((response) => {
        this.teams = response.data;
      });
    },

    fetchAssets(lotto) {
      this.axios.get(`/commesse/${lotto}/assets`)
        .then(res => {
          this.assets = (res.data && res.data.data) ? res.data.data : [];
          this.fetchInterventions();
        }).catch(err => {
          console.error("Errore recupero asset:", err);
          this.fetchInterventions();
        });
    },

    fetchInterventions() {
      let params = {};
      if (this.lavoro.fk_asset) {
        const asset = this.assets.find(a => a.id === this.lavoro.fk_asset);
        if (asset && asset.fk_asset_type) {
          params.asset_type_id = asset.fk_asset_type;
        }
      }
      this.axios.get('my-interventions', { params }).then((response) => {
        this.interventi = Array.isArray(response.data) ? response.data : [];
      });
    },

    onAssetChange() {
      this.fetchInterventions();
    },

    onInterventoChange() {
      if (this.lavoro && this.lavoro.intervento) {
        const selectedInt = this.interventi.find(i => i.codice === this.lavoro.intervento);
        if (selectedInt) {
          this.lavoro.fk_module = selectedInt.fk_module;
          // If the current asset does not belong to the new module, reset it!
          if (this.lavoro.fk_asset) {
            const asset = this.assets.find(a => a.id === this.lavoro.fk_asset);
            if (asset && asset.fk_module !== this.lavoro.fk_module) {
              this.lavoro.fk_asset = null;
            }
          }
        }
      }
    },

    // confirmNewRevision
    //
    // Use sweet-alert to confirm
    confirmNewRevision() {
      if (this.lavoro.deleted) {
        return;
      }
      if (this.assetsForModule.length > 0 && !this.lavoro.fk_asset) {
        this.$swal.fire({
          icon: "error",
          title: "Asset richiesto",
          text: "Devi selezionare un asset per salvare la revisione.",
        });
        return;
      }
      this.$swal
        .fire({
          title: "Nuova revisione",
          text: "Procedendo verrà creata una nuova revisione per questo lavoro",
          icon: "warning",
          showCancelButton: true,
          confirmButtonText: "Sì, genera",
          cancelButtonText: "Annulla",
        })
        .then((result) => {
          if (result.value) {
            let formData = new FormData();
            formData.append("version", this.ultimaRevisione);
            formData.append("intervento", this.lavoro.intervento);
            formData.append("distanza", this.lavoro.distanza);
            formData.append("numero_buche", this.lavoro.numero_buche);
            formData.append("foto_inizio", this.fotoInizio);
            formData.append("foto_fine", this.fotoFine);
            if (this.lavoro.team && this.lavoro.team.id) {
              formData.append("team_id", this.lavoro.team.id);
            }
            if (this.lavoro.fk_asset) {
              formData.append("fk_asset", this.lavoro.fk_asset);
            } else {
              formData.append("fk_asset", "");
            }
            this.axios
              .put(`dockyard/${this.$route.params.uuid}/versions`, formData)
              .then((response) => {
                if (response.data["success"]) {
                  this.$router.go();
                } else {
                  this.$swal.fire({
                    icon: "error",
                    text: "Errore inatteso",
                  });
                }
              });
          }
        });
    },

    // confirmDeletion
    //
    // Use sweet-alert to confirm
    confirmDeletion() {
      this.$swal
        .fire({
          title: "Elimina lavoro",
          text:
            "Procedendo verrà eliminato questo lavoro che non sarà più presente nei report",
          icon: "warning",
          showCancelButton: true,
          confirmButtonText: "Sì, elimina",
          cancelButtonText: "Annulla",
        })
        .then((result) => {
          if (result.value) {
            let formData = new FormData();
            formData.append("del_status", "true");
            this.axios
              .put(`dockyard/${this.$route.params.uuid}/delete`, formData)
              .then((response) => {
                if (response.data["success"]) {
                  this.$router.go();
                } else {
                  this.$swal.fire({
                    icon: "error",
                    text: "Errore inatteso",
                  });
                }
              });
          }
        });
    },

    // confirmReopen
    //
    // Use sweet-alert to confirm
    confirmReopen() {
      this.$swal
        .fire({
          title: "Ripristina lavoro",
          text:
            "Procedendo verrà ripristinato questo lavoro che sarà nuovamente presente nei report",
          icon: "warning",
          showCancelButton: true,
          confirmButtonText: "Sì, ripristina",
          cancelButtonText: "Annulla",
        })
        .then((result) => {
          if (result.value) {
            let formData = new FormData();
            formData.append("del_status", "false");
            this.axios
              .put(`dockyard/${this.$route.params.uuid}/delete`, formData)
              .then((response) => {
                if (response.data["success"]) {
                  this.$router.go();
                } else {
                  this.$swal.fire({
                    icon: "error",
                    text: "Errore inatteso",
                  });
                }
              });
          }
        });
    },

    downloadPDF() {
      this.$swal.fire({
        title: "Generazione PDF...",
        text: "Attendere la creazione della relazione.",
        allowOutsideClick: false,
        didOpen: () => {
          this.$swal.showLoading();
        }
      });

      this.axios({
        url: `dockyard/${this.$route.params.uuid}/pdf`,
        method: 'GET',
        responseType: 'blob',
      })
      .then((response) => {
        this.$swal.close();
        const url = window.URL.createObjectURL(new Blob([response.data]));
        const link = document.createElement('a');
        link.href = url;
        link.setAttribute('download', `Relazione_Lavoro_${this.lavoro.id}.pdf`);
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
      })
      .catch((error) => {
        console.error("Errore download PDF:", error);
        this.$swal.close();
        this.$swal.fire({
          icon: "error",
          title: "Errore",
          text: "Impossibile generare la relazione in formato PDF.",
        });
      });
    },

    // processFoto
    //
    // Used for upload image
    processFoto(event, type) {
      var target = event.target.files[0];
      if (type == "fine") {
        this.fotoFine = target;
      } else {
        this.fotoInizio = target;
      }
    },

    classeInterventoBadge(intervento) {
      if (!intervento) return 'badge-secondary';
      const lower = typeof intervento === 'string' ? intervento.toLowerCase() : String(intervento).toLowerCase();
      if (lower.includes('buca')) {
        return 'badge-success';
      }
      if (lower.includes('sfalcio')) {
        return 'badge-primary';
      }
      if (lower.includes('segnaletica')) {
        return 'badge-dark';
      }
      if (lower.includes('rifiuto_speciale')) {
        return 'badge-purple';
      }
      if (lower.includes('rifiuto')) {
        return 'badge-warning';
      }
      if (lower.includes('emergenza') || lower.includes('palo')) {
        return 'badge-danger';
      }
      if (lower.includes('pulizia') || lower.includes('cestino')) {
        return 'badge-secondary';
      }
      return 'badge-secondary';
    },

    // Format Timestamp to Local Date
    formatTimestampToLocalDate(ts) {
      if (ts) {
        const today = new Date();
        var tsDate = new Date(ts * 1000);
        if (
          today.getDate() == tsDate.getDate() &&
          today.getMonth() == tsDate.getMonth() &&
          today.getFullYear() == tsDate.getFullYear()
        ) {
          return `Oggi, ${tsDate.toLocaleTimeString()}`;
        } else {
          return tsDate.toLocaleString();
        }
      } else {
        return "-";
      }
    },
  },
};
</script>

<style scoped>
/* Page Header Icon */
.cw-header-icon {
  width: 48px; height: 48px; border-radius: 14px;
  background: linear-gradient(135deg, #F7931E, #E07B00);
  display: flex; align-items: center; justify-content: center;
  box-shadow: 0 4px 12px rgba(247,147,30,0.35);
}
.cw-header-icon .mdi { color: #fff; font-size: 1.5rem; }

/* Card Sezione */
.cw-card {
  background: #fff;
  border-radius: 16px;
  box-shadow: 0 2px 16px rgba(0,0,0,0.07);
  padding: 28px;
  border: 1px solid rgba(0,0,0,0.05);
}

/* Section Title con Step */
.cw-section-title {
  font-size: 0.82rem; font-weight: 700;
  text-transform: uppercase; letter-spacing: 0.08em;
  color: #64748b; margin-bottom: 22px;
  display: flex; align-items: center;
}
.cw-step-num {
  width: 22px; height: 22px; border-radius: 50%;
  background: linear-gradient(135deg, #F7931E, #E07B00);
  color: #fff; font-size: 0.7rem; font-weight: 800;
  display: inline-flex; align-items: center; justify-content: center;
  margin-right: 10px; flex-shrink: 0;
}

/* Field Label */
.cw-label {
  font-size: 0.75rem; font-weight: 700;
  text-transform: uppercase; letter-spacing: 0.07em;
  color: #94a3b8; margin-bottom: 8px; display: block;
  text-align: left;
}

/* Input con Icona */
.cw-input-wrap { position: relative; display: flex; align-items: center; }
.cw-field-icon {
  position: absolute; left: 12px;
  color: #94a3b8; font-size: 1rem; z-index: 2; pointer-events: none;
}
.cw-input {
  width: 100%; height: 46px; padding: 0 14px 0 36px;
  border: 1.5px solid #e2e8f0; border-radius: 10px;
  background: #f8fafc; font-size: 0.92rem; font-weight: 500; color: #1e293b;
  transition: border-color 0.2s, box-shadow 0.2s; outline: none;
  text-align: left;
}
.cw-input:focus {
  border-color: #F7931E;
  box-shadow: 0 0 0 3px rgba(247,147,30,0.12);
  background: #fff;
}

/* Select con Icona */
.cw-select-wrap { position: relative; display: flex; align-items: center; }
.cw-select {
  width: 100%; height: 46px; padding: 0 38px 0 36px;
  border: 1.5px solid #e2e8f0; border-radius: 10px;
  background: #f8fafc; appearance: none; -webkit-appearance: none;
  font-size: 0.92rem; font-weight: 500; color: #1e293b;
  cursor: pointer; transition: border-color 0.2s, box-shadow 0.2s; outline: none;
  text-align: left;
}
.cw-select:focus {
  border-color: #F7931E;
  box-shadow: 0 0 0 3px rgba(247,147,30,0.12);
  background: #fff;
}
.cw-select-arrow {
  position: absolute; right: 14px;
  color: #94a3b8; font-size: 1rem; pointer-events: none;
}

/* Alert Warning */
.cw-alert-warning {
  background: #fffbeb; border-radius: 10px;
  padding: 12px 16px; border: 1px solid #fde68a;
  color: #92400e; font-size: 0.85rem; font-weight: 500;
  text-align: left;
}

/* Bottone Submit */
.cw-btn-submit {
  display: inline-flex; align-items: center;
  padding: 10px 28px; border: none; border-radius: 30px;
  background: linear-gradient(135deg, #F7931E, #E07B00);
  color: #fff; font-size: 0.9rem; font-weight: 700;
  cursor: pointer; box-shadow: 0 4px 14px rgba(247,147,30,0.35);
  transition: all 0.2s;
}
.cw-btn-submit:hover:not(:disabled) {
  background: linear-gradient(135deg, #E07B00, #C96A00);
  box-shadow: 0 6px 18px rgba(247,147,30,0.45);
  transform: translateY(-1px);
}
.cw-btn-submit:disabled { opacity: 0.55; cursor: not-allowed; transform: none; }

/* Form Footer */
.cw-footer {
  background: #fff; border-radius: 14px;
  padding: 18px 24px; border: 1px solid rgba(0,0,0,0.05);
  box-shadow: 0 2px 12px rgba(0,0,0,0.05);
}

/* Coppia Chiave-Valore */
.detail-item { margin-bottom: 16px; text-align: left; }
.detail-label { 
  font-size: 0.72rem; color: #94a3b8; 
  text-transform: uppercase; letter-spacing: 0.05em; 
  margin-bottom: 4px; font-weight: 600; 
}
.detail-value { font-size: 0.95rem; color: #1e293b; font-weight: 500; }

/* Tabella Premium */
.au-table { width: 100%; border-collapse: collapse; text-align: left; }
.au-table thead tr { border-bottom: 2px solid #f1f5f9; }
.au-table thead th {
  padding: 10px 16px; font-size: 0.72rem; font-weight: 700;
  text-transform: uppercase; letter-spacing: 0.07em; color: #94a3b8;
  background: #f8fafc;
}
.au-table tbody tr { border-bottom: 1px solid #f1f5f9; transition: background 0.15s; }
.au-table tbody tr:hover { background: #f8fafc; }
.au-table td { padding: 14px 16px; vertical-align: middle; }

/* Riga attiva della tabella */
.active-row {
  background-color: #FEF1E0 !important;
}
.active-row td {
  font-weight: 600;
  color: #E07B00;
}

/* Zona Pericolosa e Bottoni Relativi */
.au-btn-danger {
  display: inline-flex; align-items: center; padding: 10px 22px;
  border-radius: 30px; border: 1.5px solid #fecaca; background: #fff5f5;
  color: #991b1b; font-size: 0.88rem; font-weight: 700; cursor: pointer; transition: all 0.15s;
}
.au-btn-danger:hover { background: #fee2e2; border-color: #ef4444; }

.au-btn-warning {
  display: inline-flex; align-items: center; padding: 8px 18px;
  border-radius: 20px; border: 1.5px solid #fde68a; background: #fffbeb;
  color: #92400e; font-size: 0.82rem; font-weight: 700; cursor: pointer; transition: all 0.15s;
}
.au-btn-warning:hover { background: #fef3c7; border-color: #f59e0b; }

/* Bottone Light Custom */
.cw-btn-light {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  padding: 8px 24px;
  font-size: 0.88rem;
  font-weight: 600;
  border-radius: 30px;
  background: #ffffff;
  color: #64748b;
  border: 1.5px solid #e2e8f0;
  cursor: pointer;
  transition: all 0.2s ease-in-out;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.02);
}
.cw-btn-light:hover {
  background: #FEF1E0;
  border-color: #F5B871;
  color: #E07B00;
  transform: translateY(-1px);
  box-shadow: 0 4px 12px rgba(247, 147, 30, 0.15);
  text-decoration: none;
}
.cw-btn-light:active {
  transform: translateY(0);
}
</style>